import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import { FaEye, FaPaperPlane } from 'react-icons/fa';
import { useApp } from '../App';
import './Chefs.css';

const ROLES = ['All', 'Chef', 'Housekeeper', 'Receptionist', 'Cleaner'];

function Chefs() {
  const [professionals, setProfessionals] = useState([]);
  const [role, setRole] = useState('All');
  const [searchParams] = useSearchParams();
  const search = searchParams.get('search') || '';
  const { setShowRequest, setPreselectedPro } = useApp();
  const [cvItem, setCvItem] = useState(null);

  useEffect(() => {
    const params = {};
    if (role && role !== 'All') params.role = role;
    if (search) params.search = search;
    axios.get('https://api.hospifylink.com/api/professionals', { params })
      .then(r => { if (Array.isArray(r.data)) setProfessionals(r.data); })
      .catch(() => {});
  }, [role, search]);

  const handleRequest = (pro) => {
    setPreselectedPro(pro);
    setShowRequest(true);
  };

  const safeProfessionals = Array.isArray(professionals) ? professionals : [];

  return (
    <div className="chefs-root">
      <div className="chefs-hero fade-in">
        <h1>Our Professionals</h1>
        <p>Browse by service and find your perfect match</p>
      </div>

      <div className="chefs-categories">
        {ROLES.map(r => (
          <button
            key={r}
            className={`chefs-cat-btn ${role === r ? 'chefs-cat-active' : ''}`}
            onClick={() => setRole(r)}
          >
            {r}
          </button>
        ))}
      </div>

      {search && (
        <p className="chefs-search-info">Search results for: <b>{search}</b></p>
      )}

      <div className="chefs-grid">
        {safeProfessionals.map((c, i) => (
          <div key={c.id} className="chefs-card fade-up" style={{ animationDelay: `${i * 0.05}s` }}>
            <div className="chefs-img-wrap">
              <img src={c.image || 'https://via.placeholder.com/400'} alt={c.name} />
              <span className="chefs-badge">{c.role}</span>
            </div>
            <div className="chefs-body">
              <h3>{c.name}</h3>
              <p className="chefs-specialty">{c.specialty}</p>
              <p className="chefs-exp">{c.experience}</p>
              <div className="chefs-btns">
                <button className="chefs-view" onClick={() => setCvItem(c)}>
                  <FaEye /> CV
                </button>
                <button className="chefs-request" onClick={() => handleRequest(c)}>
                  <FaPaperPlane /> Request
                </button>
              </div>
            </div>
          </div>
        ))}
        {safeProfessionals.length === 0 && <p className="chefs-empty">No professionals found.</p>}
      </div>

      {cvItem && (
        <div className="chefs-modal" onClick={() => setCvItem(null)}>
          <div className="chefs-modal-box" onClick={e => e.stopPropagation()}>
            <img src={cvItem.image} alt={cvItem.name} className="chefs-modal-img" />
            <h3>{cvItem.name}</h3>
            <p className="chefs-modal-role">
              {cvItem.role} • {cvItem.category} • {cvItem.specialty}
            </p>
            <p><b>Experience:</b> {cvItem.experience}</p>
            <p className="chefs-modal-bio">{cvItem.bio}</p>
            <button
              className="lca-btn-primary"
              onClick={() => { setCvItem(null); handleRequest(cvItem); }}
            >
              Request This Professional
            </button>
            <button className="chefs-modal-close" onClick={() => setCvItem(null)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Chefs;
